import { telephonyApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const USER_TELEPHONY_ACTION_TYPE = createNamedActions('userTelephony', {
  GET_USER_TELEPHONY: 'GET_USER_TELEPHONY',
});

export const getUserTelephonyAction = catchAsyncActionError(({ userId }) => async dispatch => {
  const { data } = await telephonyApi.getTelephonyUserExtensionData({ userId });

  return dispatch({
    type: USER_TELEPHONY_ACTION_TYPE.GET_USER_TELEPHONY,
    payload: data,
  });
});
